export class Pagination {
    total: number
    count: number
    perPage: number
    currentPage: number
    totalPages: number

    constructor(
        pagination: {
            total: number
            count: number
            per_page: number
            current_page: number
            total_pages: number
        },
    ) {
        this.total = pagination.total
        this.count = pagination.count
        this.perPage = pagination.per_page
        this.currentPage = pagination.current_page
        this.totalPages = pagination.total_pages
    }

    static default(): Pagination {
        return {
            total: 0,
            count: 0,
            perPage: 15,
            currentPage: 1,
            totalPages: 1,
        }   
    }
}

export const DEFAULT_PER_PAGE = 15